import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "./dateButton.css";

DateButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  selectDate: PropTypes.func,
  currentDate: PropTypes.string,
};

export default function DateButton(props) {
  const { name, value, selectDate, currentDate } = props;
  const [currentName, setCurrentName] = useState([]);
  const [active, setActive] = useState("");

  useEffect(() => {
    setCurrentName(name.split(", "));
  }, [name]);

  useEffect(() => {
    if (value === currentDate) {
      setActive("active");
    } else {
      setActive("");
    }
  }, [value, currentDate]);

  return (
    <button
      type="button"
      className={`dateButton ${active}`}
      onClick={() => selectDate(value)}
    >
      <p className="dateButton-day">{currentName[0]}</p>
      <p>{currentName[1]}</p>
    </button>
  );
}
